import { CircleNotch as Loader2 } from '@phosphor-icons/react';
import './TimeSlotPicker.css';

export function TimeSlotPicker({ slots, selectedTime, onSelectTime, loading }) {
  if (loading) {
    return (
      <div className="time-slot-picker__state time-slot-picker__state--loading">
        <Loader2 size={32} className="time-slot-picker__spinner" />
        <span className="time-slot-picker__loading-text">Loading available slots...</span>
      </div>
    );
  }

  if (!slots || slots.length === 0) {
    return (
      <div className="time-slot-picker__state">
        <p>No available slots for this date.</p>
        <p className="time-slot-picker__hint">Please select a different date.</p>
      </div>
    );
  }

  const availableSlots = slots.filter((s) => s.available);

  if (availableSlots.length === 0) {
    return (
      <div className="time-slot-picker__state">
        <p>All slots are booked for this date.</p>
        <p className="time-slot-picker__hint">Please select a different date.</p>
      </div>
    );
  }

  return (
    <div>
      <p className="time-slot-picker__count">{availableSlots.length} slots available</p>
      <div className="time-slot-picker__grid">
        {slots.map((slot) => (
          <button
            key={slot.time}
            type="button"
            onClick={() => slot.available && onSelectTime(slot.time)}
            disabled={!slot.available}
            className={`time-slot-picker__slot${
              selectedTime === slot.time ? ' time-slot-picker__slot--selected' : ''
            }`}
          >
            {slot.time}
          </button>
        ))}
      </div>
    </div>
  );
}
